import axios from "axios";
import {
  verify,
  ForgottPassword,
  Login,
  VerifyEmail,
  SendOTP,
  VerifyOtp,
  SignUp,
} from "../common/api";

export const forgotPassword = async (user) => {
  try {
    const response = await axios.post(ForgottPassword, { user });
    return response.data;
  } catch (error) {
    throw new Error(
      "Failed to send Forgot Password request. Please try again."
    );
  }
};


export const signIn = async (usr, pwd) => {
  try {
    const response = await fetch(Login, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        usr: usr,
        pwd: pwd,
      }),
    });

    // parse JSON response body (backend returns structured message on error)
    const data = await response.json().catch(() => ({}));

    // If HTTP status is not ok, surface backend message or HTTP status
    if (!response.ok) {
      const msg = data?.message?.message || data?.message || data?.status || 'Failed to sign in';
      throw new Error(msg);
    }

    // Some endpoints return application-level status_code in body
    const statusCode = data?.status_code || data?.message?.status_code || data?.message?.status_code;

    if (statusCode === 403 || (data?.message && data.message.status_code === 403)) {
      // Explicit forbidden (e.g., role missing)
      const errMsg = data?.message?.message || data?.message || 'Forbidden';
      const err = new Error(errMsg);
      err.code = 403;
      throw err;
    }

    // Success path: expect token in response JSON
    if (data && data.token) {
      return data;
    }

    // Fallback: no token
    const fallback = data?.message?.message || data?.message || 'User Not Found';
    throw new Error(fallback);
  } catch (error) {
    // preserve 403 code if present so UI can react differently
    throw new Error(error.message || "Error signing in. Please provide valid credentials");
  }
};


export const verifyEmail = async (email, fullName) => {
  try {
    const response = await axios.post(VerifyEmail, {
      email: email,
      verf_link: verify,
      full_name: fullName,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to send verification email:", error);
    throw error;
  }
};

export const sendOTP = async (phone, otp) => {
  try {
    const response = await axios.post(SendOTP, {
      phone: `${phone}`,
      otp: otp,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to send OTP:", error);
    throw error;
  }
};


export const verifyOTP = async (phone, otp) => {
  try {
    const response = await axios.post(VerifyOtp, {
      phone: phone,
      otp: otp,
    });
    return response;
    // Optionally return the response data
  } catch (error) {
    console.error("OTP verification failed:", error);
    throw new Error("OTP verification failed. Please try again.");
  }
}


export const signUp = async (email, phone, fullName) => {
  try {
    const response = await axios.post(SignUp, {
      email: email,
      phone: phone,
      full_name: fullName,
    });

    return response.data.message.status_code;
  } catch (error) {
    throw error;
  }
};